import React from "react";
import { services } from "../mock";
import { Shovel, Fence, Trees, Route, Grid3x3, Layers } from "lucide-react";
import { Button } from "../components/ui/button";

const iconMap = { Shovel, Fence, Trees, Route, Grid3x3, Layers };

const Services = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <div className="text-brand-yellow text-sm font-bold tracking-[0.3em] mb-3">
            OUR SERVICES
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-brand-dark leading-tight">
            COMPLETE SOLUTIONS FOR YOUR OUTDOOR SPACES
          </h2>
          <div className="w-16 h-1 bg-brand-yellow mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-lg p-8 shadow-sm hover:shadow-2xl border border-gray-100 hover:border-brand-yellow/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-14 h-14 bg-brand-dark rounded-md flex items-center justify-center mb-6 group-hover:bg-brand-yellow transition-colors duration-300">
                  {Icon && (
                    <Icon
                      className="text-brand-yellow group-hover:text-brand-dark transition-colors duration-300"
                      size={26}
                    />
                  )}
                </div>
                <h3 className="font-display text-xl text-brand-dark mb-3 tracking-wide">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
                <div className="mt-6 flex items-center gap-2 text-xs font-bold tracking-wider text-brand-yellow opacity-0 group-hover:opacity-100 transition-opacity">
                  LEARN MORE
                  <span className="transition-transform group-hover:translate-x-1">→</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex justify-center mt-16">
          <Button
            onClick={() => scrollTo("contact")}
            className="bg-brand-dark hover:bg-brand-dark-2 text-white font-bold tracking-wider text-sm px-10 py-7 rounded-md shadow-md hover:shadow-xl transition-all"
          >
            REQUEST A FREE QUOTE
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
